import { Directive, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { PermissionsService } from "./permissions.service";
import { UserPermissions } from "../../pages/login-page/login-page-data/login.types";
import { Subject, takeUntil } from "rxjs";

@Directive({
  selector: "[mhHasPermission]",
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input("mhHasPermission") resource!: keyof UserPermissions;

  private destroy$ = new Subject<void>();

  constructor(private el: ElementRef, private permissionsService: PermissionsService) {}

  ngOnInit() {
    this.permissionsService
      .hasPermission(this.resource)
      .pipe(takeUntil(this.destroy$))
      .subscribe((hasPermission) => {
        if (!hasPermission) {
          this.el.nativeElement.style.display = "none";
        } else {
          this.el.nativeElement.style.display = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
